import { Box, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import type { GroupMeta } from "../../settings/groups";

interface Props {
  items: GroupMeta[];
  active?: string;
  onSelect: (id: string) => void;
}

export default function SettingsNav({ items, active, onSelect }: Props) {
  return (
    <List dense disablePadding sx={{ position: "sticky", top: 16 }}>
      {items.map((item) => (
        <ListItemButton
          key={item.id}
          selected={item.id === active}
          onClick={() => onSelect(item.id)}
          sx={{
            borderRadius: "8px",
            mb: 0.25,
            py: 0.75,
            "&.Mui-selected": {
              bgcolor: "primary.50",
              color: "primary.main",
              "&:hover": { bgcolor: "primary.100" },
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: 30, color: "inherit" }}>
            <Box sx={{ display: "flex", fontSize: 16 }}>{item.icon}</Box>
          </ListItemIcon>
          <ListItemText primary={item.title} primaryTypographyProps={{ fontSize: 13, fontWeight: 500 }} />
        </ListItemButton>
      ))}
    </List>
  );
}
